import React from 'react';
import { BookOpenIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
const assurances = [{
  label: 'Instant Digital Access',
  Icon: ZapIcon
}, {
  label: 'Secure Checkout',
  Icon: LockIcon
}, {
  label: 'Ready-to-Use Resources',
  Icon: BookOpenIcon
}];
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-103" data-mp="1zaxdoel1wsuz">
      <div className="mx-auto max-w-4xl text-center" data-id="element-104" data-mp="1ucvvdvvg8xkk">
        <p className="inline-flex items-center rounded-[8px] border border-brand-gold/40 bg-brand-ivory px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-105" data-mp="1ubb0g5583cm6">
          For Cosmetology Instructors & Beauty Educators
        </p>

        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-106" data-mp="exojzyr615c6">
          Get Your Next Cosmetology Class <Accent data-id="element-107" data-mp="38gus9nrq729z">Ready in 5 Minutes.</Accent>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-108" data-mp="3dfxrusoxsgak">
          Stop creating teaching materials from scratch.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-109" data-mp="34e83jvqcpxh0">
          A complete, skin-first teaching system to help you prepare faster, explain more clearly and
          teach with confidence.
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Cosmetology Instructor Ready — six teaching volumes shown with interior pages on tablet, laptop and phone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain lg:max-w-[900px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(91, 63, 176, 0.18))'
    }} data-id="element-110" data-mp="2uieljwtv5bru" />

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-111" data-mp="hadmpqr38brx">
        <strong className="font-semibold text-brand-charcoal" data-id="element-112" data-mp="cibzj9sdt0n4">6 Structured Volumes + 5 Ready-to-Use Bonuses</strong>{' '}
        covering skin science, skin analysis, client assessment, facial care, cosmetic ingredients and
        professional teaching tools.
      </p>

      <CtaBlock label="Get Cosmetology Instructor Ready" className="mt-9" data-id="element-113" data-mp="10980awetf66i" />

      <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-114" data-mp="w74mw28l5ril">
        {assurances.map(({
        label,
        Icon
      }) => <li key={label} className="flex items-center gap-1.5 font-body text-[12px] text-brand-charcoal/60" data-id="element-115" data-mp="r78elqsuvdx8">
            <Icon className="h-3.5 w-3.5 text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-116" data-mp="m85b4asixfrd" />
            {label}
          </li>)}
      </ul>
    </section>;
}